import React from 'react';
import PropTypes from 'prop-types';
import { Link, navigate } from 'gatsby'
import _ from 'lodash'
import { useTranslation } from 'react-i18next';

const defaultUrl = {
  'nl': '/',
  'en': '/en/'
}

/* The class titles in switch links cannot be translated, language of these
   titles is the language where the link refers to (site in other language) */
const languageLinkTitles = {
  'nl': "Website in het Nederlands",
  'en': "Website in English"
}

const Switcher = ({ language, urls, clickCallback }) => {
  const { i18n } = useTranslation();
  return (
    <div className="switcher">
      {["nl", "en"].map((code, i) => {
        const href = _.get(urls, [code, 'url', 'path'], defaultUrl[code]);
        return (
          <span key={code}>
            {i !== 0 ? '|' : ''}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href={href}
              className={code === language.toLowerCase() ? 'active' : ''}
              title={languageLinkTitles[code]}
              onClick={(e) => {
                e.preventDefault();

                if (clickCallback) {
                  clickCallback();
                }

                i18n.changeLanguage(code.toLowerCase());
                navigate(href)
              }}
            >
              {code.toUpperCase()}
            </a>
          </span>
        )
      })}
    </div>
  )
};

Switcher.propTypes = {
  language: PropTypes.string,
  urls: PropTypes.object,
};

Switcher.defaultProps = {
  language: "NL",
  urls: {}
};

export default Switcher;
